import { useState,useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useForm } from "react-hook-form"
import ApiService from "../../services/apiService"
import Update from "../table/Update"
import { method } from "lodash"
import { toast } from "react-toastify"


const UpdatePumpingStationHistory =() =>{

     const navigate = useNavigate();
     const {Id} = useParams();
     const { register, handleSubmit, setValue, formState: { errors } } = useForm();
     const [data,setData] = useState<any>()
     const[pumpingStationData,setPumpingStatiopnData] = useState<any>()

     const initialData = {
         DailyVolume:data?.dailyVolume,
         PumpNumber:data?.pumpNumber,
         Name:data?.name,
         PumpingStationId:data?.pumpingStationId,
         DateTime:data?.dateTime
     }
     

     useEffect(()=>{
         
        const getPumpingStation = async() =>{
             
            try{
                 const response = await ApiService.axiosApi('/pumpingstation',{
                      method:'GET',
                      params:{
                        pageNumber :0,
                        pageSize:0
                   }

                 })
                 if(response.success){
                     setPumpingStatiopnData(response.data.data)
                 }else{
                    console.log(response.message || "unable to get Pumping Station")
                 }
            }catch(error:any){
                  console.log(error.message || "unable to get Pumping Station")
            }
        }

        const getPumpingStationHistory = async ()=>{
                 
            try{
               const response = await ApiService.axiosApi(`/pumpingstation/history${Id}`,
                {
                     method:'GET'
                }
               )
               if(response.success){
                 setData(response.data)
               }else{
                  console.log(response.message || 'Unable to get pumping history')
               }
            }catch(error:any){
                  console.log(error.message || "Unable to get pumping history")
            }

        }

        getPumpingStation();
        getPumpingStationHistory();
        
     },[])

     const UpdatePumpStationHistory = async(data:any) =>{
         try{
             const response =await ApiService.axiosApi(`/pumpingstation/history${Id}`,{
                 method:'PUT',
                 data:data
             })
             if(response.success){
                 toast.success('Pumping Station History Updated Successfully')
                 navigate(-1)
             }else{
                 console.log(response.message || "Unable To Update Pumping Station Histyory " )
             }
         }catch(error:any){
             console.log(error.message || 'Unable To Update Pumping Station Histyory')
         }
     }
     
    return(
          <>
              <Update
                 title={'Update Pumping Station Histroy'} 
                 parentTitle={'Pumping Station History'}
                 initialData={initialData}
                 onSubmit={UpdatePumpStationHistory}
                 fields={
                      [
                         {
                            name:'DailyVolume',
                            label:'Daily Volume',
                            type:'text'
                         },
                        {
                            name: "DateTime",
                            label: "Date Time",
                            isDateTime: true,
                        }  
                      ]
                 }
               />
          </>
    )
}

export default UpdatePumpingStationHistory;